var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.454,
    height: 261.031,
    viewBox: "0 0 155.454 261.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b{font-size:56px;font-family:Novecentosans-Medium, Novecento sans;font-weight:500;}.c{letter-spacing:-0.02em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-432.03 -252.876)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.378)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M550.068,404.181l10.493-18.605a2.84,2.84,0,0,0-2.481-4.236H460.366a2.84,2.84,0,0,0-2.481,4.251L486,434.724l53.881,93.026a2.837,2.837,0,0,0,4.871.068l16.038-25.982a1.423,1.423,0,0,0,0-1.5l-13.334-21.4a1.42,1.42,0,0,0-2.481.118l-1.051,2.1a1.42,1.42,0,0,1-2.5.074l-41.179-71.568a2.84,2.84,0,0,1,2.481-4.258l44.848.211A2.837,2.837,0,0,0,550.068,404.181Z",
    transform: "translate(-25.858 -88.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M652.183,375.454l37.7-63.534h27.046L652.168,424.109a1.42,1.42,0,0,1-2.459,0l-34.692-60.293a1.42,1.42,0,0,1,1.24-2.13H641.1a1.42,1.42,0,0,1,1.24.719l7.4,13.024a1.42,1.42,0,0,0,2.44.025Z",
    transform: "translate(-134.393 -40.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M827.694,271.011l-9.1-5.154a1.42,1.42,0,0,1,.282-2.592l33.694-10.326a1.417,1.417,0,0,1,1.8,1.057l7.179,33.471A1.417,1.417,0,0,1,859.462,289l-31.009-17.56",
    transform: "translate(-274.475)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "b",
    transform: "translate(443.03 503.907)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "c",
    x: 0,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ider")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.16e615fb99cb7c2d3bcb762ce424f605.svg";
export { ForwardRef as ReactComponent };